import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useSelector } from 'react-redux';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { propLocation, propMatch } from '@/helpers/custom-prop-types';
import { isClient } from '../../../../helpers/auth';
import { usePsSlideOne } from '../../../../helpers/use/consultant_search/psSlideOne/usePsSlideOne';
import { AllLoaderComponent } from '../../../Ui/Loading';
import PsSlideOneView from './PsSlideOneView';
const ConsultantSearchPsSlideOne = (props) => {
    const { location, match } = props;
    const { search } = location;
    const auth = useSelector((state) => state.auth);
    const { defaultImageIndexMap, defaultSlideIndex, loading, mainSlide, rawSlides, slides, } = usePsSlideOne({
        match,
        search,
    });
    if (!rawSlides || loading) {
        return _jsx(AllLoaderComponent, {});
    }
    if (!isClient(auth) || !mainSlide) {
        return _jsx(CustomRedirect, { to: '/consultant' });
    }
    return (_jsx(PsSlideOneView, { defaultImageIndexMap: defaultImageIndexMap, defaultSlideIndex: defaultSlideIndex, slides: slides }));
};
ConsultantSearchPsSlideOne.propTypes = {
    location: propLocation(),
    match: propMatch(),
};
export default ConsultantSearchPsSlideOne;
